import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { deleteMapElement } from '../../../../../actions/reduxActions/mapElements';
import { saveNote, editNote } from '../../../../../actions/reduxActions/canvasNotes';

/**
 * 
 * @param {Object} note The map element metadata
 * @param {String} flowId
 * @param {String} editingToken
 * @param {Object} currentUser
 * @param {Function} save Saves the note 
 * @param {Function} remove Deletes the note
 * @param {Function} edit Toggles whether the note is read only
 * 
 * @description Form component for modifying a note 
 */
const NoteForm = ({
    note,
    flowId,
    editingToken,
    currentUser,
    save,
    remove,
    edit,
}) => {

    const subjectRef = useRef(null);
    const contentRef = useRef(null);

    const { developerName, userContent, id } = note;

    const onSave = () => {
        const { authenticationToken, tenantId } = currentUser;
        const updatedNote = { ...note, developerName: subjectRef.current.value, userContent: contentRef.current.value };
        save(updatedNote, flowId, editingToken, tenantId, authenticationToken);
    };

    const onDelete = () => {
        const { authenticationToken, tenantId } = currentUser;
        remove(id, flowId, editingToken, tenantId, authenticationToken);
    };

    return (
        <div className="note-inner note-inner-form">
            <div className="form-group">
                <input
                    placeholder="Add subject"
                    className="form-control"
                    ref={subjectRef}
                    defaultValue={developerName}
                    type="text"
                />
            </div>
            <div className="form-group">
                <textarea placeholder="Add Note" className="form-control" ref={contentRef} defaultValue={userContent} />
            </div>
            <div className="note-form-footer">
                {userContent ?
                    <button className="btn btn-sm btn-default" onClick={() => edit(id)}>Cancel</button> :
                    <button className="btn btn-sm btn-default" onClick={onDelete}>Cancel</button>
                }
                <button className="btn btn-sm btn-primary" onClick={onSave}>Save</button>
            </div>
        </div>
    );
};

const mapStateToProps = ({ currentUser }) => ({
    currentUser,
});

export default connect(mapStateToProps, { save: saveNote, remove: deleteMapElement, edit: editNote })(NoteForm);
